/* eslint-disable */
import mapCoordsData from './data/mapCoords';
import areaData from './data/area.json';
import cityData from './data/cities.json';
import prefectureData from './data/prefecture.json';

var MapWidth = 300;
var MapHeight = 211;
var MapImageURL = 'https://nta-omega-prod.s3.ap-northeast-1.amazonaws.com/public/map';
var MapTopTitle = 'Japan';
var DefaultComboText = 'Select';
var InitCount = 1;
var MapTitleIndex = 0;
var MapTextIndex = 1;
var MapCoordsIndex = 2;
var MapChildIndex = 3;

function preloadImages(a) {
  if (document.images) {
    setTimeout(function() {
      document.preload = [];
      for (var i = 0; i < a.length; i++) {
        var idx = document.preload.length;
        document.preload[idx] = new Image();
        document.preload[idx].src = a[i];
      }
    }, 100);
  }
}

function createClassAttr(args) {
  var ary_cls = [];
  if (args.length > 0) {
    for (var i = 0; i < args.length; i++) {
      if (args[i] instanceof Array) {
        for (var j = 0; j < args[i].length; j++) {
          if (args[i][j]) ary_cls.push(args[i][j]);
        }
      } else {
        if (args[i]) ary_cls.push(args[i]);
      }
    }
    if (ary_cls.length > 0) {
      return ' class="' + ary_cls.join(' ') + '"';
    } else {
      return '';
    }
  } else {
    return '';
  }
}

function getTargetElm(a) {
  return a.srcElement ? a.srcElement : a.target ? a.target : null;
}

function al(a, b) {
  if (hasClassName(a, b)) {
    return;
  } else {
    var cls = a.className;
    a.className = cls + (cls ? ' ' : '') + b;
    return;
  }
}
function removeClassName(a, b) {
  if (a === null || a.className === null) return;
  var c = a.className.split(' ');
  var n = [],
    found = false;
  for (var i = 0, l = c.length; i < l; i++) {
    if (c[i] === b) {
      found = true;
    } else {
      n.push(c[i]);
    }
  }
  if (found) a.className = n.join(' ');
  return found;
}
function hasClassName(a, b) {
  if (a === null || a.className === null) return false;
  var c = a.className.split(' ');
  for (var i = 0, l = c.length; i < l; i++) {
    if (c[i] === b) return true;
  }
  return false;
}

function _evt(event, type, level, code) {
  event.preventDefault();
  var srcElement;
  if (event) {
    srcElement = getTargetElm(event);
  }

  if (type && (/AD_/.test(type) || /CA_/.test(type))) {
    type = type
      .replace(/_M_\d+/, '')
      .replace(/_F_\d+/, '')
      .replace(/_\d+/, '');
  }
  switch (type) {
    case 'SetZone':
      if (!code && srcElement && srcElement.tagName && srcElement.tagName.toLowerCase() === 'select') {
        code = srcElement.value;
      }
      if (!code) {
        if (level === 'pref') {
          level = 'direction';
        } else if (level === 'area') {
          level = 'pref';
        } else if (level === 'district') {
          level = 'area';
        }
        code = map.getValue(level);
      }
      map.set(level, code, level.match(/^(area|district)$/));

      break;
    case 'Map_over':
      var mTitle = document.getElementById('map_title_' + level + '_' + code);
      var mTooltip = document.getElementById('map_tooltip_' + level + '_' + code);
      if (mTitle && hasClassName(mTitle, 'na')) return false;
      if (mTitle || mTooltip) {
        al(mTitle, 'over');
      }
      var mo = document.getElementById('map_over_' + level + '_' + code);
      if (mo) {
        mo.style.zIndex = 1;
      }
      break;
    case 'Map_out':
      var mTitle = document.getElementById('map_title_' + level + '_' + code);
      var mTooltip = document.getElementById('map_tooltip_' + level + '_' + code);
      if (mTitle && hasClassName(mTitle, 'na')) return false;
      if (mTitle || mTooltip) {
        removeClassName(mTitle, 'over');
      }
      var mo = document.getElementById('map_over_' + level + '_' + code);
      if (mo) {
        mo.style.zIndex = -1;
      }
      break;

    default:
      break;
  }

  if (srcElement && srcElement.tagName) {
    var tagName = srcElement.tagName.toLowerCase();
    switch (tagName) {
      case 'select':
        window.focus();
        break;
      case 'img':
        if (srcElement.parentNode && srcElement.parentNode.blur) {
          try {
            srcElement.parentNode.blur();
          } catch (e) {}
        }
        break;
      case 'a':
        if (srcElement.blur) {
          try {
            srcElement.blur();
          } catch (e) {}
        }
        break;
      default:
        break;
    }
  }
  return false;
}
window._evt = _evt;

function NtaMap(mapId, ZoneTopicPathId) {
  var x = this;
  var self = x;
  x.area = {};
  x.district = {};
  x.pref = {};
  x.getValue = function(a) {
    if (a) {
      var z = self.selectedZoneObject;
      while (z) {
        if (z.level === a) {
          return z.cd;
        }
        z = z.parent;
      }
      return null;
    } else {
      if (self.selectedZoneObject) {
        return self.selectedZoneObject.cd;
      } else {
        return null;
      }
    }
  };
  x.renderTopicPath = function() {
    var ary_chain = self.getSelectionChain();
    var ary_topicPath = [];
    var ary_textPath = [];
    if (ary_chain.length > 0) {
      ary_topicPath.push("<a href=\"javascript:void(0);\" onClick=\"return _evt(event, 'SetZone', '', '')\">" + MapTopTitle + '</a>  ');
      for (var i = 0; i < ary_chain.length; i++) {
        var z = ary_chain[i];
        if (z.ary_child && z.ary_child.length === 1) continue;
        if (i === ary_chain.length - 1) {
          ary_topicPath.push(z.title);
        } else {
          ary_topicPath.push(
            '<a href="javascript:void(0);" onClick="return _evt(event, \'SetZone\', \'' + z.level + "', '" + z.cd + '\')">' + z.title + '</a>  ',
          );
        }
        var prnt = z.parent;
        if (prnt && prnt.ary_child && prnt.ary_child.length === 1) {
          prnt = prnt.parent;
        }
        ary_textPath.push(
          '<a href="javascript:void(0);" onClick="return _evt(event, \'SetZone\', \'' +
            (prnt ? prnt.level : '') +
            "', '" +
            (prnt ? prnt.cd : '') +
            '\')">' +
            z.title +
            '</a>  ',
        );
      }
    } else {
      ary_topicPath.push(MapTopTitle);
    }
    if (self.Elements.TopicPath) {
      self.Elements.TopicPath.innerHTML = ary_topicPath.join(' &gt; ');
    }
  };

  x.getZoneObject = function(a) {
    var o = self.decode(a);
    var ret = null;
    if (o.MajMat) {
      ret = self.zoneObject[o.MajMat];
      if (o.Region) {
        ret = ret.child[o.Region];
        if (o.Area) {
          ret = ret.child[o.Area];
        }
      }
    }
    return ret;
  };

  x.set = function(level, code) {
    var z = self[level] ? self[level][code] : null;
    if (z && z === self.selectedZoneObject) {
      if (z.parent) {
        if (z.parent.ary_child && z.parent.ary_child.length === 1 && z.parent.parent) {
          self.selectedZoneObject = z.parent.parent;
        } else {
          self.selectedZoneObject = z.parent;
        }
      } else {
        self.selectedZoneObject = null;
      }
    } else {
      if (z) {
        if (z.ary_child && z.ary_child.length === 1) {
          console.log(z.coords);
          self.selectedZoneObject = z.ary_child[0];
        } else {
          self.selectedZoneObject = z;
        }
      } else {
        self.selectedZoneObject = null;
      }
    }
    self.onSelectZone(self.selectedZoneObject);

    if (self.Elements.Map) this.renderMap(true);
    self.renderTopicPath();
  };

  x.getSelectionChain = function() {
    var ary = [];
    if (self.selectedZoneObject) {
      var z = self.selectedZoneObject;
      while (z) {
        ary.push(z);
        z = z.parent;
      }
    }
    return ary.reverse();
  };
  x.getChildArray = function(a) {
    var z = a && a.cd ? a : self.getZoneObject(a);
    var ret = [];
    if (z) {
      for (var code in z.child) {
        ret.push(z.child[code]);
      }
    }
    return ret;
  };

  x.renderMap = function() {
    var ary_chain = self.getSelectionChain();
    var bottomMap = 'pref';
    var ary_imagePath = [MapImageURL],
      mapElement;
    if (ary_chain.length > 0 && bottomMap) {
      for (var i = 0; i < ary_chain.length; i++) {
        var z = ary_chain[i];
        ary_imagePath.push(z.cd);
        if (z.level === bottomMap || i === ary_chain.length - 1) {
          mapElement = z;
          break;
        }
      }
    } else {
      mapElement = self.zoneObject;
    }
    var children = mapElement.child ? mapElement.child : mapElement;
    var imagePath = ary_imagePath.join('/');
    var ary_src = [];
    var buf = [];
    buf.push('\r\n<img src="');
    buf.push(imagePath);
    buf.push('/area.gif" width="');
    buf.push(MapWidth);
    buf.push('" height="');
    buf.push(MapHeight);
    buf.push('" usemap="#imageMap">\r\n');
    buf.push('\r\n<div class="mapText">\r\n');
    for (var code in children) {
      var z = children[code];
      if (!z.titleCoords) continue;
      var pos = 'style="top:' + z.titleCoords[1] + 'px;left:' + z.titleCoords[0] + 'px;"';

      var ary_cls = ['box'];
      if (z === self.selectedZoneObject || (self.selectedZoneObject && z === self.selectedZoneObject.parent)) {
        ary_cls.push('sel');
      }
      buf.push('\r\n\t<div id="map_title_');
      buf.push(z.level);
      buf.push('_');
      buf.push(code);
      buf.push('"\r\n\t\t');
      buf.push(createClassAttr(ary_cls));
      buf.push('\r\n\t\t');
      buf.push(pos);
      buf.push("\r\n\t\tonClick=\"_evt(event, 'SetZone', '");
      buf.push(z.level);
      buf.push("', '");
      buf.push(code);
      buf.push("', true)\"\r\n\t\tonMouseOver=\"_evt(event, 'Map_over', '");
      buf.push(z.level);
      buf.push("', '");
      buf.push(code);
      buf.push("');\"\r\n\t\tonMouseOut=\"_evt(event, 'Map_out', '");
      buf.push(z.level);
      buf.push("', '");
      buf.push(code);
      buf.push('\');"\r\n\t\t>');
      buf.push(z.mapTitle);
      buf.push('</span>\r\n\t</div>\r\n');
      if (z.ary_child) {
        buf.push('\r\n\t<div class="map-tooltip"\r\n\t\t');
        buf.push(pos);
        buf.push(">\r\n\t\t<span onMouseOver=\"_evt(event, 'Map_over', '");
        buf.push(z.level);
        buf.push("', '");
        buf.push(code);
        buf.push("');\" onMouseOut=\"_evt(event, 'Map_out', '");
        buf.push(z.level);
        buf.push("', '");
        buf.push(code);
        buf.push('\');" >\r\n\t\t\t<a href="#" onclick="_evt(event, \'SetZone\', \'');
        buf.push(z.level);
        buf.push("', '");
        buf.push(code);
        buf.push('\', true)">');
        buf.push(z.mapTitle);
        buf.push('</a>\r\n');
        var tLevel, tCode, tTitle;
        for (var key in z.ary_child) {
          if (z.ary_child[key]['mapTitle']) {
            tLevel = z.ary_child[key]['level'];
            tCode = z.ary_child[key]['cd'];
            tTitle = z.ary_child[key]['mapTitle'];
            buf.push('\r\n\t\t\t<div id="map_tooltip_');
            buf.push(tLevel);
            buf.push('_');
            buf.push(tCode);
            buf.push('">\r\n');
            buf.push('\r\n\t\t\t\t<a href="#" onclick="_evt(event, \'SetZone\', \'');
            buf.push(tLevel);
            buf.push("', '");
            buf.push(tCode);
            buf.push('\')">');
            buf.push(' <i class="icon-chevron-right"></i>');
            buf.push(tTitle);
            buf.push('</a>\r\n');

            buf.push('\r\n\t\t\t</div>\r\n');
          }
        }
        buf.push('\r\n\t\t</span>\r\n\t</div>\r\n');
      }
    }
    buf.push('\r\n</div>\r\n');
    buf.push('\r\n<div class="mapLayer">\r\n');
    for (var code in children) {
      var z = children[code];
      if (!z.titleCoords) continue;
      ary_src.push(imagePath + '/' + code + '_o.gif');
      ary_src.push(imagePath + '/' + code + '_g.gif');
      buf.push('\r\n\t<img id="map_over_');
      buf.push(z.level);
      buf.push('_');
      buf.push(code);
      buf.push('"\r\n\tsrc="');
      buf.push(imagePath);
      buf.push('/');
      buf.push(code);
      buf.push('_o.gif"\r\n\twidth=');
      buf.push(MapWidth);
      buf.push('\r\n\theight=');
      buf.push(MapHeight);
      buf.push('\r\n\tusemap="#imageMap">\r\n\t<img id="map_gray_');
      buf.push(z.level);
      buf.push('_');
      buf.push(code);
      buf.push('"\r\n\tsrc="');
      buf.push(imagePath);
      buf.push('/');
      buf.push(code);
      buf.push('_g.gif"\r\n\twidth=');
      buf.push(MapWidth);
      buf.push('\r\n\theight=');
      buf.push(MapHeight);
      buf.push('\r\n\tusemap="#imageMap">\r\n');
    }
    buf.push('\r\n</div>\r\n');
    buf.push('\r\n<map name="imageMap" id="imageMap">\r\n');
    for (var code in children) {
      var z = children[code];
      if (!z.titleCoords) continue;
      var ary_coords = z.coords;
      if (!z.decompressed) {
        ary_coords = decompressCoord(ary_coords);
        z.decompressed = true;
      }
      for (var i = 0; i < ary_coords.length; i++) {
        var coords = ary_coords[i];
        var type = coords.length === 3 ? 'circle' : coords.length === 4 ? 'rect' : 'poly';
        buf.push('\r\n\t<area shape="');
        buf.push(type);
        buf.push('" coords="');
        buf.push(coords.join(','));
        buf.push('" alt="');
        buf.push(z.title);
        buf.push('"\r\n\tid="map_area_');
        buf.push(code);
        buf.push("\"\r\n\tonMouseOver=\"_evt(event, 'Map_over', '");
        buf.push(z.level);
        buf.push("', '");
        buf.push(code);
        buf.push("');\"\r\n\tonMouseOut=\"_evt(event, 'Map_out', '");
        buf.push(z.level);
        buf.push("', '");
        buf.push(code);
        buf.push("');\"\r\n\tonClick=\"return _evt(event, 'SetZone', '");
        buf.push(z.level);
        buf.push("', '");
        buf.push(code);
        buf.push('\', true);"\r\n\tonFocus="this.blur ? this.blur() : \'\'"\r\n\thref="javascript:void(0);">\r\n');
      }
    }
    buf.push('\r\n</map>\r\n');
    self.Elements.Map.innerHTML = buf.join('');
    preloadImages(ary_src);
  };

  x.init = function(onSelectZone) {
    self.dataCount = null;
    self.Elements = { Map: document.getElementById(mapId), TopicPath: document.getElementById(ZoneTopicPathId) };
    self.selectedZoneObject = null;
    self.onSelectZone = onSelectZone;
    createMapData();
    var ary_option = [{ value: '', innerHTML: DefaultComboText }];
    for (var code in self.direction) {
      var o = self.direction[code];
      ary_option.push({ value: code, innerHTML: o.title });
    }
  };

  function createMapData() {
    self.zoneObject = {};
    self.direction = {};
    self.pref = {};
    self.area = {};
    self.district = {};
    for (var d in mapCoordsData) {
      if (d === '00') continue;
      var direction = mapCoordsData[d];
      self.zoneObject[d] = {
        level: 'direction',
        paramName: 'Direction',
        cd: d,
        mapTitle: direction[MapTitleIndex],
        title: direction[MapTitleIndex].replace(/<br>/, ''),
        titleCoords: direction[MapTextIndex],
        coords: direction[MapCoordsIndex],
        child: {},
        ary_child: [],
        decompressed: false,
        selected: false,
        count: InitCount,
      };
      self.direction[d] = self.zoneObject[d];
      for (var p in direction[MapChildIndex]) {
        var pref = direction[MapChildIndex][p];
        var parent = self.zoneObject[d];
        parent.child[p] = {
          level: 'pref',
          paramName: 'Pref',
          cd: p,
          mapTitle: pref[MapTitleIndex],
          title: pref[MapTitleIndex].replace(/<br>/, ''),
          titleCoords: pref[MapTextIndex],
          coords: pref[MapCoordsIndex],
          child: {},
          ary_child: [],
          parent: parent,
          decompressed: false,
          selected: false,
          count: InitCount,
        };
        parent.ary_child.push(parent.child[p]);
        self.pref[p] = parent.child[p];
        let prefArea = prefectureData.find(x => x.code === p).areaCodes;
        for (var i in prefArea) {
          let areaCode = prefArea[i];
          var area = pref[MapChildIndex][areaCode] || {};

          let areaTitle = areaData.find(x => x.code === areaCode)?.name || area[MapTitleIndex];
          var parent = self.zoneObject[d].child[p];

          parent.child[areaCode] = {
            level: 'area',
            paramName: 'Area',
            cd: areaCode,
            mapTitle: areaTitle,
            title: areaTitle,
            titleCoords: area[MapTextIndex],
            coords: area[MapCoordsIndex],
            child: {},
            ary_child: [],
            parent: parent,
            decompressed: false,
            selected: false,
            count: InitCount,
          };
          parent.ary_child.push(parent.child[areaCode]);
          self.area[areaCode] = parent.child[areaCode];
          var area_district = areaData?.find(x => x.code === areaCode);

          if (area_district) {
            var cityCodes = area_district.cityCodes;
            for (var dist = 0; dist < cityCodes.length; dist++) {
              var di = cityData?.find(a => a.code === cityCodes[dist]);

              var parent = self.zoneObject[d].child[p].child[areaCode];
              parent.child[di.code] = {
                level: 'district',
                paramName: 'District',
                cd: di.code,
                mapTitle: di.name,
                title: di.name,
                titleCoords: '',
                coords: '',
                parent: parent,
                decompressed: false,
                selected: false,
                count: InitCount,
              };

              parent.ary_child.push(parent.child[di.code]);
              self.district[di.code] = parent.child[di.code];
            }
          }
        }
      }
    }
  }
  function decompressCoord(a) {
    for (var i = 0; i < a.length; i++) {
      var coords = a[i];
      var ary = [];
      var prev1, prev2, val;
      for (var p = 0; p < coords.length; p++) {
        if (typeof coords !== 'string') {
          continue;
        }
        var c = coords?.charAt(p);
        if (c.match(/[a-z]/)) {
          val = prev2 + (c.charCodeAt(0) - 96);
        } else if (c.match(/[A-Z]/)) {
          val = prev2 - (c.charCodeAt(0) - 64);
        } else if (c === '_') {
          val = prev2;
        } else {
          var sign = 1;
          if (c === ',') c = coords.charAt(++p);
          if (c === '-') {
            sign = -1;
            c = coords.charAt(++p);
          }
          val = 0;
          while (c.match(/[0-9]/)) {
            val = val * 10 + (c - 0);
            c = coords.charAt(++p);
          }
          val *= sign;
          p--;
        }
        ary.push(val);
        prev2 = prev1;
        prev1 = val;
      }
      a[i] = ary;
    }
    return a;
  }
}

var map = new NtaMap('Map', 'ZoneTopicPath');

export default map;
